// Copyright (c) Mysten Labs, Inc.
// SPDX-License-Identifier: Apache-2.0

// @generated by protobuf-ts 2.9.6 with parameter force_server_none,optimize_code_size,ts_nocheck
// @generated from protobuf file "sui/rpc/v2/signature_scheme.proto" (package "sui.rpc.v2", syntax proto3)
// tslint:disable
// @ts-nocheck
//
// Copyright (c) Mysten Labs, Inc.
// SPDX-License-Identifier: Apache-2.0
//
/**
 * Flag use to disambiguate the signature schemes supported by Sui.
 *
 * Note: the enum values defined by this proto message exactly match their
 * expected BCS serialized values when serialized as a u8. See
 * [enum.SignatureScheme](https://mystenlabs.github.io/sui-rust-sdk/sui_sdk_types/enum.SignatureScheme.html)
 * for more information about signature schemes.
 *
 * @generated from protobuf enum sui.rpc.v2.SignatureScheme
 */
export enum SignatureScheme {
	/**
	 * @generated from protobuf enum value: ED25519 = 0;
	 */
	ED25519 = 0,
	/**
	 * @generated from protobuf enum value: SECP256K1 = 1;
	 */
	SECP256K1 = 1,
	/**
	 * @generated from protobuf enum value: SECP256R1 = 2;
	 */
	SECP256R1 = 2,
	/**
	 * @generated from protobuf enum value: MULTISIG = 3;
	 */
	MULTISIG = 3,
	/**
	 * @generated from protobuf enum value: BLS12381 = 4;
	 */
	BLS12381 = 4,
	/**
	 * @generated from protobuf enum value: ZKLOGIN = 5;
	 */
	ZKLOGIN = 5,
	/**
	 * @generated from protobuf enum value: PASSKEY = 6;
	 */
	PASSKEY = 6,
}
